import React, {useContext, useEffect} from "react";
import {Link} from 'react-router-dom'
import {useForm, FormProvider} from "react-hook-form";

import Button from '@mui/material/Button';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

import {Loading} from '../../custom/LoadingComponent'
import * as CustomStyles from '../../styles/CustomStyles';
import * as WorksiteFragment from './WorksiteFragmentComponent';
import BucketContext from "../../context/BucketContext";
import * as ReduxDataStatus from '../../../utils/constants/ReduxDataStatus';
import * as AFFragment from '../../custom/AFFragment';


const WorksiteManagement = (props) => {
    console.log('WorksiteManagement Component___');
    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        if(bucketContext.bucket.mostRecentWsId != null) {
            console.log('Reseting the mostRecentWsId: ' + JSON.stringify(bucketContext.bucket.mostRecentWsId));
            bucketContext.setBucketValue({mostRecentWsId: null});
        }
        props.loadComponentData(props.employer.id);
    });

    const methods = useForm({
        defaultValues: {
            lWorksite: props.worksite
        } 
    });
    const handleSubmit = methods.handleSubmit;

    const handleSubmitWsUpdate = (data, event) => {
        const worksite = data.lWorksite;

        props.saveWorksite(worksite);
    }

    if(props.dataStatus === ReduxDataStatus.IDLE || 
        props.dataStatus === ReduxDataStatus.LOADING) {
            return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    return(
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>

            <Stack spacing={1} sx={{marginBottom: 2}}>
                <Box>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                        <Link to={`/employers/${props.employer.id}`}>{props.employer.generalSection.employerName}</Link>
                        <Typography color="text.primary">
                            Punct de lucru
                        </Typography>
                    </Breadcrumbs>
                </Box>       

                <Box>
                    <h3>{props.worksite.generalSection.name}</h3>
                </Box>
                <hr/>

                <FormProvider {...methods} > 
                <form id='worksiteConstructionManageForm' onSubmit={handleSubmit(handleSubmitWsUpdate)}>
                    <WorksiteFragment.WorksiteDetails
                    />

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                            <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza</Button>
                        </Grid>
                    </Grid>

                    <AFFragment.UpdateDetailsSection entity={props.worksite}/>
                </form>
                </FormProvider>

            </Stack>
        </Box>
        </Container>
    );
}

export default WorksiteManagement;